// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentRequestForm_wrapper","button":"PaymentRequestForm_button"};